<div>
  <button nzType="primary" (click)="close()" nz-button>Confirm</button>
</div>
<nz-row nzGutter="12">
  <!-- <footer-toolbar errorCollect>
    <button nz-button type="primary" nzType="primary">Lưu</button>
    <button nz-button (click)="close()">Đóng</button>
  </footer-toolbar> -->
</nz-row>
 